module.exports = "../fonts/SFUIText-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Light.ttf
// module id = 579
// module chunks = 0